module.exports = __webpack_public_path__ + "img/sharre-tip.f62b1e80.png";